import React, { useState, useEffect, useContext } from 'react';
import { IoChevronBackCircle } from "react-icons/io5";
import { TiDelete } from "react-icons/ti";
import { FiDownload } from "react-icons/fi";
import { Grid } from '@material-ui/core';
import CertificatesService from 'services/certificates.service';
import AuthContext from 'store/AuthContext';
import AppButton from 'components/FormsUI/AppButton/appButton';
import AppPagination from "components/common/AppPagination";
import AppSkeleton from 'components/common/skeleton/AppSkeleton';
import { AppTableNoData } from 'components/common/AppTableUtils';
import ToastContext from 'store/ToastContext';
import './CertificatesManagement.css';
import { Modal } from 'react-bootstrap';
import NewCertificatePopup from './NewCertificatePopup';
import { useFormik } from 'formik';
import Select from 'react-select';
import AirlinesService from '../../services/airlines.servicse';


export default function CertificatesManagement(props) {
    const { userInfo } = useContext(AuthContext);
    const { openToast } = useContext(ToastContext);
    const [data, setData] = useState([]);
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });    
    const [message, setMessage] = useState("");
    const [showAddModal, setShowAddModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [hostNameToDelete, setHostNameToDelete] = useState("");
    const { location: { state: { airlineCode: selectedAirlineCode = null } = {} } } = props;
    const airlineCode = userInfo.isOwner ? selectedAirlineCode : userInfo.airlineCode;  
    const [selectedAirline, setSelectedAirline] = useState("");
    const [airlines, setAirlines] = useState([]);    

    
    useEffect(() => {
        const fetchData = async (airlineCode) => {        
            setSpinnerLoading(true);
            var list = await CertificatesService.getCertificates(airlineCode);        
            setData(list);
            
            if (userInfo.isOwner === true)
            {
                AirlinesService.GetAirlinesWithoutAdministrator()
                .then(setAirlines)
                .catch(setAirlines);
            }
            setSpinnerLoading(false);
        }         
        if (userInfo.isOwner === false) {
            fetchData(airlineCode);
        }
        else {
            fetchData(selectedAirline);
        }                             
    }, [showAddModal, selectedAirline, airlineCode, userInfo.isOwner]);    

    const backhandler = () => {
        props.history.goBack();
    }       
      
    const deleteConfirm = async (hostName) => {                        
        setMessage('Are you sure you want to delete the certificate?');
        setShowModal(true);  
        setHostNameToDelete(hostName);               
    }

    const HandleDeleteCertificate = async (hostNameToDelete) => {
        setSpinnerLoading(true);
                  
        var response = await CertificatesService.deleteCertificate(hostNameToDelete);
        
        setShowModal(false);
        
        if (response === true)
        {
            openToast("Certificate was deleted successfully", "success");
            setSpinnerLoading(true);
            var list = await CertificatesService.getCertificates(airlineCode);        
            setData(list);
            setSpinnerLoading(false);
        }
        else
            openToast("An error occured while trying to delete the certificate", "error");
                
    }

    const handleClose = () => {
        setSpinnerLoading(false);        
        setShowModal(false);        
    }

    const handleClosePopup = () => {
        setShowAddModal(false);                
    }    

    const handleCreateCertificate = async () => { 
        if (data.length === 5)
        {
            openToast("You have reached the maximum number of certificates for an airline", "info");        
            return;
        }
        setShowAddModal(true);                     
    }

    const handlePrivatekey = async(airlineCode) => {          
        var data = await CertificatesService.downloadPrivatekey(airlineCode);                    
        
        var fileLink = document.createElement("a");        
        const file = Buffer.from(data['privateKey']);
        fileLink.href = window.URL.createObjectURL(new Blob([file]));
        fileLink.download = airlineCode + ".key";
        fileLink.click();        
        fileLink.remove();             
    }

    const handlePemkey = async(hostName, airlineCode) => {        
        var data = await CertificatesService.downloadPemkey(hostName);                    
        
        var fileLink = document.createElement("a");        
        const file = Buffer.from(data['pemKey']);
        fileLink.href = window.URL.createObjectURL(new Blob([file]));
        fileLink.download = airlineCode + ".pem";
        fileLink.click();   
        fileLink.remove();             
    }

    const handleSelectChange = async(values) => {        
        setSelectedAirline(values?.value);             
        formik.values.Airline = values?.value;
    }

    const formik = useFormik({
        initialValues: {
            Airline: ''
        },
        onSubmit: async (values) => {
        }     
    });   
    
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    { 
                        userInfo.role === "admin" ? 
                            <h2 className='col'>{"Certificates Management for Airline " + airlineCode}</h2> :                        
                                <>
                                    <h2 className='col'>Certificates Management</h2>
                                    <div>
                                        <h5 className='col'>Filter By Airline:</h5>
                                        <Select                        
                                            options={airlines}
                                            value={airlines?.filter(option => option.value === formik.values.Airline)}
                                            onChange={(values) => handleSelectChange(values)}
                                            isClearable={true}
                                        />
                                    </div>
                                </>                            
                    }                                             
                    <Grid container>
                        <Grid item xs={6}>                                                    
                        </Grid>  
                    </Grid>                                                          
                </div>
                <div>
                {userInfo.role === "admin" && (
                    <AppButton label="Create Certificate" action={() => handleCreateCertificate()}></AppButton>
                )}
                <Modal show={showAddModal} onHide={handleCreateCertificate}>
                    <Modal.Header >
                        <Modal.Title>Create Certificate</Modal.Title>
                        <span style={{ cursor: "pointer" }} onClick={handleClosePopup}>X</span>
                    </Modal.Header>
                    <Modal.Body>
                        <NewCertificatePopup setShowAddModal={setShowAddModal} />
                    </Modal.Body>
                </Modal>
                </div>
                <div>
                    {spinnerLoading ? <AppSkeleton rows={paginationObject.pageSize} cols={6} variant="table" size="28px"/> : (
                        <React.Fragment>
                            <table className="table table-hover table-sm table-bordered">
                            <thead>
                                <tr>
                                    {userInfo.isOwner && <th scope="col">Airline Code</th>}                                    
                                    <th scope="col">Host Name</th>
                                    <th scope="col">IP Address</th>
                                    <th scope="col">Create Date</th>
                                    <th scope="col">Create Time</th>
                                    <th scope="col">Validity Date</th>   
                                    <th scope="col">Status</th>
                                    <th scope="col">Private Key</th>
                                    <th scope="col">PEM Key</th>
                                    {!userInfo.isOwner &&
                                        <th scope="col">Delete Certificate</th>
                                    }                                                                     
                                </tr>
                            </thead>
                            <tbody>
                                {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            {
                                                userInfo.isOwner && 
                                                    <td className="col">
                                                        {
                                                            data?.airlineCode                                                      
                                                        }
                                                    </td>
                                            }                                                
                                            <td className="col">{data?.hostName}</td>
                                            <td className="col">{data?.ipAddress}</td>
                                            <td className="col">{new Date(data?.createDate).toLocaleDateString()}</td>                                                                                        
                                            <td className="col">{new Date(data?.createTime).toLocaleTimeString()}</td>
                                            <td className="col">{new Date(data?.validityDate).toLocaleDateString()}</td>                                                                                                                                                                                
                                            <td className="col">{data?.status}</td>
                                            <td className="col">
                                                <AppButton action={() => handlePrivatekey(data.airlineCode)} 
                                                           isLoading={spinnerLoading} 
                                                           label=""                                                           
                                                           size="lg"                                                                                                                    
                                                           icon={<FiDownload />}>
                                                </AppButton>
                                            </td>
                                            <td className="col">
                                                <AppButton action={() => handlePemkey(data.hostName, data.airlineCode)} 
                                                           isLoading={spinnerLoading} 
                                                           label=""                                                           
                                                           size="lg"
                                                           icon={<FiDownload />}>
                                                </AppButton>
                                            </td>
                                            {!userInfo.isOwner &&
                                                <td className="col">                                                    
                                                    <AppButton action={() => deleteConfirm(data.hostName)} 
                                                                isLoading={spinnerLoading} 
                                                                label=""
                                                                color="danger"
                                                                size="lg"
                                                                icon={<TiDelete />}>
                                                    </AppButton>                                                  
                                                </td>
                                            }
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                            {!data.length ? <AppTableNoData /> :
                                    <AppPagination
                                        pageSize={paginationObject.pageSize}
                                        totalRecords={data.length}
                                        currentPage={paginationObject.currPage}
                                        endIndex={paginationObject.endIndex}
                                        startIndex={paginationObject.startIndex}
                                        setPaginationObject={(ele) => {
                                            setPaginationObject((data) => {
                                                return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                                            })
                                        }}
                                    ></AppPagination>
                                }
                        </React.Fragment>)
                    }
                </div>
                <div className="marginAtTop">
                    <AppButton icon={<IoChevronBackCircle />} action={backhandler} label="Back"></AppButton>
                </div>              
                <div>
                    <Modal show={showModal} backdrop="static">
                        <Modal.Header >
                            <Modal.Title>Delete Certificate</Modal.Title>
                            <span style={{ cursor: "pointer" }} onClick={handleClose}>X</span>
                        </Modal.Header>
                        <Modal.Body>{message}</Modal.Body>
                        <Modal.Footer>
                            <div className="col-2">                                
                                <AppButton action={() => HandleDeleteCertificate(hostNameToDelete)} label="Yes" isLoading={spinnerLoading} isBlock={true}></AppButton>                                                                                                
                            </div>
                            <div className="col-2">
                                <AppButton action={() => handleClose()} label="No" disabled={spinnerLoading} color="secondary" isBlock={true}></AppButton>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div> 
        </div>         
        </>
    )
}